<template>
    <div>
        <div class="loaded-content" v-if="hasSomething && !isLoading">
            <slot></slot>
        </div>
        <div class="empty-content" v-if="!hasSomething && !isLoading">
            <slot name="empty">
                <div class="alert alert-info" role="alert">
                    No data in the database.
                </div>
            </slot>
        </div>
        <div class="loading-content" v-if="isLoading">
            <slot name="loading">
                <div class="alert alert-info" :class="loadingClass" role="alert">
                    <i class="fas fa-cog fa-spin"></i> Loading...
                </div>
            </slot>
        </div>
    </div>
</template>


<script>

    import jquery from 'jquery';

    export default {
        name: 'AsyncWait',
        props: ['init', 'rows'],
        data() {
            return {
                loading: false,
                data: false,
                getter: false,
                loadingClass: {
                    'alert': true,
                    'alert-info': true
                }
            };
        },
        created() {
            this.initialize();
        },
        methods: {
            initialize() {
                const dispatch = this.init.dispatch;

                if (typeof this.rows !== 'undefined') {
                    this.data = this.rows;
                }

                if (typeof this.init.getter !== 'undefined') {
                    this.getter = this.init.getter;
                }

                if (typeof this.init.loadingClass !== 'undefined') {
                    const o = {};
                    this.init.loadingClass.split(' ').forEach(function(e) {
                        o[e] = true;
                    });
                    this.loadingClass = jquery.extend(this.loadingClass, o);
                }
                else {
                    this.loadingClass = jquery.extend(this.loadingClass, {'mt-3': true});
                }

                if (typeof dispatch !== 'undefined') {
                    this.initDispatch(dispatch);
                }

            },
            initDispatch(dispath) {
                this.loading = true;
                if (typeof this.rows === 'undefined') {
                    this.data = false;
                }

                if (typeof dispath === 'function') {
                    dispath((data) => {
                        this.loading = false;
                        if (typeof data !== 'undefined') {
                            this.data = data;
                        }
                    });
                }
                else {
                    this.$store.dispatch(dispath).then(() => {
                        this.loading = false;
                    });
                }
            },
            setData(data) {
                this.data = data;
            },
            refresh() {
                this.initialize();
            }
        },
        computed: {
            isLoading: function() {
                return this.loading === true;
            },
            isEmpty: function() {
                return !this.storeData || !this.storeData.length;
            },
            hasSomething: function() {
                if (!this.storeData) return false;

                return this.storeData.constructor === Array ? this.storeData.length > 0 : this.storeData;
            },
            storeData: function() {
                if (this.init.dispatch) {
                    return this.$store.getters[this.getter ? this.getter : this.init.dispatch];
                }
                return [];
            }
        },
        mounted() {

        }
    };

</script>

<style>

</style>
